// filestack Reusable Methods
import { mapState } from "vuex";

export const filestack = {
  data: () => ({
    downloadurl: "https://cdn.filestackcontent.com/",
    output: ""
  }),
  computed: {
    ...mapState({
      integration: state => state.integration
    })
  },
  methods: {
    createURL(handle) {
      return (
        this.downloadurl +
        this.integration.fsAPIKey +
        this.output +
        "/security=policy:" +
        this.integration.fsReadPolicy +
        ",signature:" +
        this.integration.fsReadSignature +
        "/" +
        handle
      );
    }
  }
}